export const theme = {
  colors: {
    white: '#FFF',
    black: '#000000',
    customBlack: '#0D1317',
    dark: '#373636',
    lesDark: '#5B5B5B',
    darkRed: '#650000',
    darkBrown: 'rgba(27, 16, 16, 80%)',
    beige: '#B79D5A',
    darkBeige: '#7D6200',
    lightGray: '#E3E3E3',
    gray: '#D9D9D9',
    darkGray: '#C9C9C9'
  },
  fontSize: {
    xxl: '40px',
    xl: '36px',
    l: '30px',
    m: '24px',
    s: '20px',
    xs: '16px',
    xxs: '12px',
    desktop: {
      xxl: '70px',
      xl: '60px'
    }
  },
  fontWeight: {
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    extraBold: 800
  }
};
